export default {
  // authorized: (state) => !!state.token,
  // authstatus: (state) => state.authStatus,
  // currentUser: (state) => state.user,
  // isAuth: (state) => state.isAuthenticated,
};
